export const DICTIONARY_CATEGORY = {
  PREFIX: 'codeNamePrefixes',
  SUFFIX: 'codeNameSuffixes',
  RACE: 'codeRace',
  SEX: 'codeSex',
  ETHNICITY: 'codeEthnicity',
  EYE_COLOR: 'codeEyeColor',
  HAIR_COLOR: 'codeHairColor',
  HAIR_STYLE: 'codeHairStyle',
  HAIR_LENGTH: 'codeHairLength',
  BLOOD_TYPE: 'codeBloodType',
  HANDED: 'codeHanded',
  STATE: 'codeStates',
  CITY: 'codeCities',
  COUNTY: 'codeCounties',
  COUNTRY: 'codeCountries',
  DEATH_CAUSE: 'codeDeathCauses',
  RESIDENT: 'codeResident',
  CITIZENSHIP: 'codeCitizenships',
  NATIONALITY: 'codeNationalities',
  GANG: 'codeGang',
  MARITAL_STATUS: 'codeMaritalStatus',
  LANGUAGE: 'codeLanguages',
  DANGEROUS_TYPE: 'codeDangerousType',
  CONTACT_TYPE: 'codeContactInfoMethodTypes',
  CONTACT_METHOD_TYPE: 'ContactMethods',
};

export const CONTACT_METHOD_TYPE = {
  PHONE: 'Phone',
  EMAIL: 'Email',
};

export const NAME_SNAPSHOT_FIELDS = [
  'FirstName',
  'MiddleName',
  'LastName',
  'NickName',
  'Prefix',
  'Suffix',
];

export const DEFAULT_VALUES = {
  Prefix: '',
  FirstName: '',
  MiddleName: '',
  LastName: '',
  Suffix: '',
  NickName: '',

  GeneralAppearance: '',
  Race: '',
  Sex: '',
  Height: '',
  Weight: '',

  Born: '',
  ptsBirthCityID: null,
  BirthState: '',
  BirthCounty: '',
  BirthCountry: '',
  Deceased: false,
  Died: '',
  CauseOfDeath: '',

  LocalResident: '',
  IsUSCitizen: true,
  CurrentCitizenship: '',
  BirthCitizenship: '',
  BirthNationality: '',

  Gang: '',
  MaritalStatus: '',
  EducationLevel: '',
  Allergies: '',
  DNA: '',
  Notes: '',

  Ethnicity: '',
  EyeColor: '',
  Handed: '',
  BloodType: '',
  HairColor: '',
  HairLength: '',
  HairStyle: '',

  SSN: '',
  OLN: '',
  OLNState: '',

  ptsAddressID: null,
  IsPrimaryAddress: false,
  ContactMethodType: '',
  ContactType: '',
  ContactInfo: '',
  IsDefaultContact: false,
  ContactNotes: '',

  PrintsAvailable: false,
  OverrideJuvenile: false,
  PublicOfficial: false,
  PrimaryLanguage: '',
  EnglishLangIndicator: false,
  HasDigitalImage: false,
  Incarcerated: false,
  ConcealedWeaponPermit: false,
  Dangerous: false,
  WhyDangerous: '',
  IsOrganDonor: false,
  ExFelon: false,
  ProtectiveOrder: false,
  SeniorCitizen: false,
  Officer: false,
  SexOffender: false,
  Juvenile: false,
  Military: false,
  Probation: false,
};
